import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Save } from 'lucide-react';
import ImageUpload from '../../components/admin/ImageUpload';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminContact = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState({
    id: null,
    email: '',
    phone: '',
    location_en: '',
    location_tr: '',
    intro_en: '',
    intro_tr: '',
    image: ''
  });

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${BACKEND_URL}/api/admin/contact`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data) {
        setContent(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(`${BACKEND_URL}/api/admin/contact`, content, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('İletişim bilgileri kaydedildi');
    } catch (error) {
      toast.error('Kaydetme hatası');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading">Yükleniyor...</div>;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>İletişim Bilgileri Düzenle</h1>
        <button onClick={handleSave} disabled={saving} className="btn-primary">
          <Save size={20} />
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </div>

      <div className="admin-form">
        <div className="form-section">
          <h3>İletişim Görseli</h3>
          <ImageUpload
            currentImage={content.image}
            onImageUploaded={(url) => setContent({ ...content, image: url })}
          />
        </div>

        <div className="form-section">
          <h3>İletişim Bilgileri</h3>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={content.email}
              onChange={(e) => setContent({ ...content, email: e.target.value })}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>Telefon</label>
            <input
              type="text"
              value={content.phone}
              onChange={(e) => setContent({ ...content, phone: e.target.value })}
              className="form-input"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Konum</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <input
                type="text"
                value={content.location_en}
                onChange={(e) => setContent({ ...content, location_en: e.target.value })}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <input
                type="text"
                value={content.location_tr}
                onChange={(e) => setContent({ ...content, location_tr: e.target.value })}
                className="form-input"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Giriş Metni (Opsiyonel)</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <textarea
                value={content.intro_en || ''}
                onChange={(e) => setContent({ ...content, intro_en: e.target.value })}
                rows="3"
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <textarea
                value={content.intro_tr || ''}
                onChange={(e) => setContent({ ...content, intro_tr: e.target.value })}
                rows="3"
                className="form-textarea"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminContact;
